import { Grid, Section } from '@gogame/components';
import React from 'react';

const CreativeSection = ({ filters }) => (
  <Section title={'Creative'}>
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <filters.CreationPeriod withFavoriteActions={true} />
      </Grid>
      <Grid item xs={4}>
        <filters.ConceptCreationPeriod withFavoriteActions={true} />
      </Grid>
      {filters.Statuses ? (
        <Grid item xs={4}>
          <filters.Statuses withFavoriteActions={true} />
        </Grid>
      ) : null}
      {filters.CreatedBy ? (
        <Grid item xs={4}>
          <filters.CreatedBy withFavoriteActions={true} />
        </Grid>
      ) : null}
      <Grid item xs={4}>
        <filters.CreativeTypes withFavoriteActions={true} />
      </Grid>
      <Grid item xs={4}>
        <filters.Languages withFavoriteActions={true} />
      </Grid>
      <Grid item xs={4}>
        <filters.MediaTypes withFavoriteActions={true} />
      </Grid>
      <Grid item xs={4}>
        <filters.Lengths withFavoriteActions={true} />
      </Grid>
      <Grid item xs={4}>
        <filters.Orientations withFavoriteActions={true} />
      </Grid>
      {filters.RequestedBy ? (
        <Grid item xs={4}>
          <filters.RequestedBy withFavoriteActions={true} />
        </Grid>
      ) : null}
      <Grid item xs={4}>
        <filters.Resolutions withFavoriteActions={true} />
      </Grid>
      <Grid item xs={4}>
        <filters.Sizes withFavoriteActions={true} />
      </Grid>
      {filters.Author ? (
        <Grid item xs={4}>
          <filters.Authors withFavoriteActions={true} />
        </Grid>
      ) : null}
      {filters.ProductionTypes ? (
        <Grid item xs={4}>
          <filters.ProductionTypes withFavoriteActions={true} />
        </Grid>
      ) : null}
      <Grid item xs={4}>
        <filters.Enhancers withFavoriteActions={true} />
      </Grid>
      <Grid item xs={4}>
        <filters.OS withFavoriteActions={true} />
      </Grid>
      <Grid item xs={4}>
        <filters.Colors withFavoriteActions={true} />
      </Grid>
      <Grid item xs={4}>
        <filters.IncludedTags withFavoriteActions={true} />
      </Grid>
      <Grid item xs={4}>
        <filters.ExcludedTags withFavoriteActions={true} />
      </Grid>
      <Grid item xs={4}>
        <filters.EndCard withFavoriteActions={true} />
      </Grid>
      {filters.Tested ? (
        <Grid item xs={4}>
          <filters.Tested withFavoriteActions={true} />
        </Grid>
      ) : null}
      {filters.AICreated ? (
        <Grid item xs={4}>
          <filters.AICreated withFavoriteActions={true} />
        </Grid>
      ) : null}
    </Grid>
  </Section>
);
export default CreativeSection;
